import { IconProps } from '../Icons.type'

export function DownIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="8"
      fill="none"
      viewBox="0 0 11 8"
      {...props}>
      <path
        fill="currentColor"
        d="M.454 2.66l3.968 3.968a1.526 1.526 0 002.16 0L10.55 2.66c.965-.965.275-2.62-1.088-2.62H1.527C.163.04-.511 1.695.454 2.66z"></path>
    </svg>
  )
}
